import React, { SVGProps } from 'react'
export const RulesSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      d="M5.4 6H3.2C1.985 6 1 6.977 1 8.182v7.636C1 17.023 1.985 18 3.2 18h17.6c1.215 0 2.2-.977 2.2-2.182V8.182A2.191 2.191 0 0 0 20.8 6h-2.2v3.273c0 .602-.492 1.09-1.1 1.09-.608 0-1.1-.488-1.1-1.09V6h-3.3v5.454c0 .603-.492 1.091-1.1 1.091-.607 0-1.1-.488-1.1-1.09V6H7.6v3.273c0 .602-.492 1.09-1.1 1.09-.607 0-1.1-.488-1.1-1.09V6Z"
    />
  </svg>
)
